<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-title align-items-start flex-column">
        <span class="font-weight-bolder text-dark">{{ getTitle() }}</span>
        <!--        -->
        <span
          class="text-muted mt-3 font-weight-bold font-size-sm"
          *ngIf="data && data.session"
          [innerHTML]="getMiniTitle() | safe : 'html'"
        ></span>
      </h3>
    </div>
  </div>
  <div class="card-body">
    <div class="card-body-progress">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <dl class="row" *ngIf="data && !data.session">
      <div class="col-sm-6">
        <div class="col-sm-12 row">
          <dt class="col-sm-12 py-2">
            <span
              class="label label-secondary font-weight-bolder label-inline mb-1"
              matTooltip="Type"
              >{{ getRealType(data.type) }}</span
            >
            <span
              class="label label-light-primary font-weight-bolder label-inline ml-2"
              *ngFor="let app of data.application_id"
              matTooltip="App"
              >{{ getApplicationName(app) }}</span
            >
          </dt>
          <dt class="col-sm-4 py-2">{{ 'COMMUNICATION.INPUT.TIME' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ getDate(data.created) }}</dd>
          <dt *ngIf="data.sender_name" class="col-sm-4 py-2">
            {{ 'COMMUNICATION.INPUT.SENDER' | translate }}
          </dt>
          <dd *ngIf="data.sender_name" class="col-sm-8 py-2">{{ data.sender_name }}</dd>
          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.SUBJECT' | translate }}</dt>
          <dd class="col-sm-8 py-2">{{ data.subject }}</dd>
          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.DESCRIPTION' | translate }}</dt>
          <dd class="col-sm-8 py-2" [innerHTML]="data.body | safe : 'html'"></dd>
          <dt *ngIf="data.receivers" class="col-sm-4 py-2">{{ 'EMAIL_FAX.TO' | translate }}</dt>
          <dd class="ml-3">
            <ul class="pl-1" style="list-style: none">
              <li *ngFor="let receiver of data.receivers">
                <span
                  class="label label-secondary font-weight-bolder label-inline mb-1 ml-1"
                  *ngIf="receiver.email"
                  >{{ receiver.email }}</span
                >
              </li>
            </ul>
          </dd>
        </div>
        <div
          class="col-sm-12 row"
          *ngIf="(loadingTags || (!loadingTags && tags.length)) && !data.received_id"
        >
          <dt class="col-sm-4 py-2">{{ 'MESSAGE.INPUT.TAG' | translate }}</dt>
          <dd class="col-sm-8 py-2">
            <div *ngIf="loadingTags">
              <mat-spinner [diameter]="20"></mat-spinner>
            </div>
            <div *ngIf="!loadingTags">
              <kt-tags [readOnly]="true" [readOnlyValue]="tags"></kt-tags>
            </div>
          </dd>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="col-sm-12">
          <dt class="col-sm-4 py-2">{{ 'MEETING.INPUT.FILES' | translate }}</dt>
          <dd class="col-sm-8 py-2">
            <kt-attachments-list [data]="attachmentData"></kt-attachments-list>
          </dd>
        </div>
      </div>
    </dl>
    <dl class="row" *ngIf="data && data.session">
      <div class="col-sm-6 row">
        <dt class="col-sm-3 py-2">Filter Type:</dt>
        <dd class="col-sm-9 py-2">{{ session.filter_type }}</dd>
        <dt class="col-sm-3 py-2">Status:</dt>
        <dd class="col-sm-9 py-2">
          {{ (session.status ? session.status.replace('_', ' ') : '') | titlecase }}
        </dd>
      </div>
      <div class="col-sm-6 row">
        <dt class="col-sm-4 py-2">Session Type:</dt>
        <dd class="col-sm-8 py-2">{{ session.session_type }}</dd>
        <dt class="col-sm-3 py-2">Call Note:</dt>
        <dd class="col-sm-9 py-2">{{ session.call_note }}</dd>
      </div>
      <div class="col-sm-6 row" *ngIf="session.call_id">
        <dt class="col-sm-4 py-2">Call Id:</dt>
        <dd class="col-sm-8 py-2">{{ session.call_id }}</dd>
      </div>
      <div class="col-sm-12" style="margin-top: 15px">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr class="text-left text-uppercase">
                <th style="min-width: 100px">entity name</th>
                <th style="min-width: 100px">entity type</th>
                <th style="min-width: 100px">action</th>
                <th style="min-width: 100px">updated</th>
                <th style="min-width: 100px">Related to</th>
              </tr>
            </thead>
            <tbody *ngIf="session.logs && session.logs.length > 0">
              <tr *ngFor="let log of session.logs" style="border-bottom: 1px solid #e8e8e85e">
                <td>
                  <span class="text-muted font-weight-bold">
                    <a
                      (click)="openDialog($event, log)"
                      class="cursor-pointer text-dark text-hover-primary font-weight-bold font-size-lg"
                    >
                      {{ log.name || 'No type' | titlecase }}
                    </a></span
                  >
                </td>
                <td>
                  <span class="text-muted font-weight-bold">{{ log.entity_type }}</span>
                </td>
                <td>
                  <span class="text-muted font-weight-bold">{{ log.action_type }}</span>
                </td>
                <td>
                  <span class="text-muted font-weight-bold d-block font-size-sm">{{
                    log.updated
                  }}</span>
                </td>
                <td>
                  <div
                    *ngIf="mapArray(log.related_to, 'CONTACT').length !== 0"
                    style="width: 313px"
                  >
                    <span>
                      <span class="text-weight-bold entity-tag">Contact: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'CONTACT') as contacts;
                          let i = index
                        "
                        [class.border-right]="i !== contacts.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('CONTACT', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >Success</a
                        >
                      </span>
                    </span>
                  </div>
                  <div
                    *ngIf="mapArray(log.related_to, 'PATIENT').length !== 0"
                    style="width: 313px"
                  >
                    <span>
                      <span class="text-weight-bold entity-tag">Patient: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'PATIENT') as patients;
                          let i = index
                        "
                        [class.border-right]="i !== patients.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('PATIENT', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip(ent.first_name, ent.last_name) }}</a
                        >
                      </span>
                    </span>
                  </div>
                  <div *ngIf="mapArray(log.related_to, 'DOCTOR').length !== 0" style="width: 313px">
                    <span>
                      <span class="text-weight-bold entity-tag">Doctor: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'DOCTOR') as doctors;
                          let i = index
                        "
                        [class.border-right]="i !== doctors.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('DOCTOR', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip(ent.first_name, ent.last_name) }}</a
                        >
                      </span>
                    </span>
                  </div>
                  <div
                    *ngIf="mapArray(log.related_to, 'FACILITY').length !== 0"
                    style="width: 313px"
                  >
                    <span>
                      <span class="text-weight-bold entity-tag">Facility: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'FACILITY') as facilities;
                          let i = index
                        "
                        [class.border-right]="i !== facilities.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('FACILITY', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip('', ent.last_name) }}</a
                        >
                      </span>
                    </span>
                  </div>
                  <div *ngIf="mapArray(log.related_to, 'CLIENT').length !== 0" style="width: 313px">
                    <span>
                      <span class="text-weight-bold entity-tag">Client: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'CLIENT') as clients;
                          let i = index
                        "
                        [class.border-right]="i !== clients.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('CLIENT', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip('', ent.last_name) }}</a
                        >
                      </span>
                    </span>
                  </div>
                  <div
                    *ngIf="mapArray(log.related_to, 'PHARMACY').length !== 0"
                    style="width: 313px"
                  >
                    <span>
                      <span class="text-weight-bold entity-tag">Pharmacy: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'PHARMACY') as pharmacies;
                          let i = index
                        "
                        [class.border-right]="i !== pharmacies.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('PHARMACY', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip('', ent.last_name) }}</a
                        >
                      </span>
                    </span>
                  </div>
                  <div
                    *ngIf="mapArray(log.related_to, 'PHARMACY_GROUP').length !== 0"
                    style="width: 313px"
                  >
                    <span>
                      <span class="text-weight-bold entity-tag">Pharmacy Group: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="
                          let ent of mapArray(log.related_to, 'PHARMACY_GROUP') as pharmacyGroups;
                          let i = index
                        "
                        [class.border-right]="i !== pharmacyGroups.length - 1"
                      >
                        <a
                          (click)="openRelatedTo('PHARMACY_GROUP', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip('', ent.last_name) }}</a
                        >
                      </span>
                    </span>
                  </div>
                  <div *ngIf="mapArray(log.related_to, 'DRUG').length !== 0" style="width: 313px">
                    <span>
                      <span class="text-weight-bold entity-tag">Drug: </span>
                      <span
                        class="pr-1 pl-1 text-success entity-name"
                        *ngFor="let ent of mapArray(log.related_to, 'DRUG') as drugs; let i = index"
                        [class.border-right]="i !== drugs.length - 1"
                        >{{ getTip('', ent.drug) }}
                        <a
                          (click)="openRelatedTo('DRUG', ent)"
                          class="btn btn-link-success font-weight-bold"
                          >{{ getTip('', ent.drug) }}</a
                        >
                      </span>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="session.logs && session.logs.length === 0">
              <tr>
                <td colspan="4">
                  <div style="text-align: center; padding: 5px">There are no logs to show</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </dl>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>{{ 'TABLE.CLOSE' | translate }}</button>
      </div>
    </div>
  </div>
</div>
